import { ValueOf } from "@claroty/utilities/types/ValueOf";
import { create } from "zustand";
import { DevicePagesModeConfig } from "../../components/Pages/Utilities/devicesViewModeConsts";
import { TOGGLE_BUTTON_ICONS } from "../../components/common/IconToggleButton/IconToggleButton";

interface PathPart {
    text: string;
    link?: string;
    count?: number;
}

interface IconToggleLink {
    text?: string;
    icon: ValueOf<typeof TOGGLE_BUTTON_ICONS>;
    link: string;
    isSelected?: boolean;
    trackingAttributes?: Record<string, string>;
}

interface DevicePageParams {
    shouldAddOverview?: boolean;
    count?: number;
    shouldAddTable?: boolean;
    modeConfig?: Partial<DevicePagesModeConfig>;
    deviceTypeFamilyName?: string;
    shouldLinkDeviceTypeFamilyName?: boolean;
    singleDeviceName?: string;
}

interface BreadcrumbsState {
    isVisible: boolean;
    pathParts: PathPart[];
    devicePageParams: DevicePageParams | undefined;
    iconsToggleLinks: IconToggleLink[];
}

interface BreadcrumbsActions {
    setPathParts: (pathParts: PathPart[], options?: { iconsToggleLinks?: IconToggleLink[] }) => void;
    setDevicePageParams: (params: { devicePageParams?: DevicePageParams; iconsToggleLinks?: IconToggleLink[] }) => void;
    reset: () => void;
}

type BreadcrumbsStore = BreadcrumbsState & BreadcrumbsActions;

const initialState: BreadcrumbsState = {
    isVisible: false,
    pathParts: [],
    devicePageParams: undefined,
    iconsToggleLinks: [],
};

export const useBreadcrumbsStore = create<BreadcrumbsStore>(set => ({
    ...initialState,
    setPathParts: (pathParts, options) =>
        set({
            isVisible: true,
            pathParts,
            devicePageParams: undefined,
            iconsToggleLinks: options?.iconsToggleLinks ?? [],
        }),
    setDevicePageParams: params =>
        set({
            isVisible: true,
            pathParts: [],
            devicePageParams: params.devicePageParams,
            iconsToggleLinks: params.iconsToggleLinks ?? [],
        }),
    reset: () => set(initialState),
}));
